<template>
  <div :class="frontStyle === 'classic' ? 'classic-navbar' : 'discord-navbar'"
    v-if="project" style="display: flex; overflow-y: auto;" id="mmnavbar">

    <!-- Barra desplegable izquierda (Classic) -->
    <v-tooltip text="Mostrar reuniones" location="bottom" v-if="frontStyle === 'classic'">
      <template #activator="{ props }">
        <v-btn @click="showLeftDrawer = true" v-bind="props" icon variant="tonal" color="primary" style="margin-right: 10px;"
          class="d-flex align-center justify-center" size="40" rounded="0">
          <v-icon>mdi-menu</v-icon>
        </v-btn>

      </template>
    </v-tooltip>

    <v-navigation-drawer
      v-model="showLeftDrawer"
      left
      temporary
      v-if="frontStyle === 'classic'"
      style="overflow-y: auto;"
    >
      <!-- Reuniones de la aplicación general -->
      <MeetingFolder title="Reuniones generales" :projectId="this.$route.params.projectId"/>

      <!-- Subproyectos -->
      <MeetingFolder
        v-for="subproject in subprojects"
        :key="subproject._id"
        :title="subproject.name"
        :projectId="subproject._id"
        :ref="subproject._id"
      />
    </v-navigation-drawer>

    <!-- Nombre del proyecto (Discord) -->
    <AppDropdown v-if="frontStyle === 'discord'" :frontStyle="frontStyle" />

    <!-- Home -->
    <div :class="frontStyle === 'discord' ? 'discord-navbar-item' : 'classic-navbar-item'" @click="home">
      <span class="mdi mdi-home" role="img" aria-label="Insert meaningful text here for accessibility" />
      Home
    </div>

    <!-- Chat -->
    <div v-if="this.project.options?.useChat" @click="goTo('MeetingWareChat')" :class="[
      frontStyle === 'discord' ? 'discord-navbar-item' : 'classic-navbar-item',
      { 'has-unread': messagesWithoutRead > 0 }
    ]">
      <span class="mdi mdi-comment" role="img" aria-label="Insert meaningful text here for accessibility" />
      Chat
      <span v-if="messagesWithoutRead > 0" class="unread-indicator">{{ messagesWithoutRead }}</span>
    </div>


    <!-- Metricas generales -->
    <div :class="frontStyle === 'discord' ? 'discord-navbar-item' : 'classic-navbar-item'" @click="goTo('MeetingWareMetrics')">
      <span class="mdi mdi-chart-bar" role="img" aria-label="Insert meaningful text here for accessibility" />
      Metricas
    </div>

    <AppDropdown v-if="frontStyle === 'classic'" :frontStyle="frontStyle" />

    <!-- Tareas -->
    <!-- Todo: arreglar la centralización de todo el navbar clásico -->
    <div :class="frontStyle === 'discord' ? 'discord-navbar-item' : 'classic-navbar-item'" @click="goTo('MeetingWareKanban')"
      v-if="this.$store.state.project.options?.useKanban && frontStyle === 'discord'">
      <span class="mdi mdi-table" role="img" aria-label="Insert meaningful text here for accessibility" />
      Tareas
    </div>

    <!-- Usuarios conectados (temporal)-->
    <div :class="frontStyle === 'discord' ? 'discord-navbar-item' : 'classic-navbar-item'" @click="toggleRightBar"
      v-if="this.$store.state.project.options?.useKanban && frontStyle === 'classic'">
      <span class="mdi mdi-account-group" role="img" aria-label="Insert meaningful text here for accessibility" />
      Miembros
    </div>

    <!-- Sprints -->
    <div :class="frontStyle === 'discord' ? 'discord-navbar-item' : 'classic-navbar-item'" @click="goTo('MeetingWareSprints')"
      v-if="this.$store.state.project.options?.isAgile">
      <span class="mdi mdi-jira" role="img" aria-label="Insert meaningful text here for accessibility" />
      Sprints
    </div>


    <PagesDropdown 
      :class="frontStyle === 'discord' ? 'discord-navbar-item' : 'classic-navbar-item'" 
      :frontStyle="frontStyle"/>
    


    <!-- Desplegable de reuniones generales-->
    <MeetingFolder 
      v-if="frontStyle === 'discord'"
      title="Reuniones generales"
      :projectId="this.$route.params.projectId"
      />

    <!-- Separaciones por subproyectos -->
    <template v-if="showSubprojects && frontStyle === 'discord'">
      <MeetingFolder
        v-for="subproject in subprojects"
        :key="subproject._id"
        :title="subproject.name"
        :projectId="subproject._id"
        :ref="subproject._id"
      />
    </template>

    <!-- Botón barra derecha -->
    <v-tooltip text="Mostrar tareas" location="bottom" v-if="frontStyle === 'classic'">
      <template #activator="{ props }">
        <v-btn @click="showRightDrawer = true" v-bind="props" icon variant="tonal" color="primary" style="margin-right: 10px;"
          class="d-flex align-center justify-center" size="40" rounded="0">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </template>
    </v-tooltip>

    <!-- Barra derecha -->
    <v-navigation-drawer
      v-model="showRightDrawer"
      location="right"
      width="1000"
      temporary
      v-if="frontStyle === 'classic'"
    >
      <KanBan />
    </v-navigation-drawer>

    <!-- Control inferior del navbar para audio y demás -->
    <!-- <div style="margin-top: auto;" v-if="frontStyle === 'discord'">
      <NavbarControl/>
    </div> -->
  </div>
</template>

<script>
import MeetingFolder from './MeetingFolder.vue';
// import NavbarControl from './navbar/NavbarControl.vue';
import api from '@/api.js';
import AppDropdown from './navbar/AppDropdown.vue';
import PagesDropdown from './navbar/PagesDropdown.vue';
import KanBan from '../pmo/KanBan.vue';

export default {
  name: 'MNavbar',
  components: {
    MeetingFolder,
    // NavbarControl,
    AppDropdown,
    PagesDropdown,
    KanBan
  },
  props: {
    frontStyle: {
      type: String,
      default: 'discord'
    }
  },
  watch: {
    '$store.state.project': {
      handler(newProject) {
        if (newProject && newProject._id) {
          this.getSubprojects();
          this.applyColor();
        }
      },
      deep: true
    }
  },
  computed: {
    messagesWithoutRead() {
      return this.$store.state.messagesWithoutRead;
    },
    project() {
      return this.$store.state.project;
    },
    email() {
      return localStorage.getItem('email');
    },
  },
  data() {
    return {
      subprojects: null,
      showSubprojects: false,

      // New meeting
      meetingsBySubproject: {},

      // Classic view
      showLeftDrawer: false,  // Reuniones generales y por subproyectos
      showRightDrawer: false  // Tareas
    }
  },
  methods: {
    toggleRightBar() {
      this.$store.commit('set', { att: 'showMembers', value: !this.$store.state.showMembers });
    },
    scrollToSubproject(id) {
      if(this.frontStyle === 'classic') return;
      let ref = this.$refs[id];
      if (Array.isArray(ref)) {
        ref = ref[0];
      }

      const dom = ref.$el || ref;
      if (dom) {
        dom.scrollIntoView({ behavior: 'smooth' });
      } else {
        console.error(`Elemento con id ${id} no encontrado.`);
      }
    },
    async getSubprojects() {
      // Verificar que project no sea null o undefined
      if (!this.$store.state.project || !this.$store.state.project._id) {
        console.warn("El proyecto aún no está cargado, se pospone la carga de reuniones.");
        return;
      }

      try {
        const response = await api.get(`/api/project/${this.$store.state.project._id}/subprojects/${this.email}`);
        this.subprojects = response.data;
        this.$store.commit('set', { att: 'subprojects', value: this.subprojects });
        this.showSubprojects = true;
      } catch (error) {
        console.error("Error cargando subproyectos:", error);
      }
    },
    home() {
      this.$router.push({
        name: "MeetingWareHome",
        params: {
          projectId: this.$route.params.projectId,
        }
      })
    },
    
    goTo(routeName){
      this.$router.push({
        name: routeName,
        params: {
          projectId: this.$route.params.projectId
        }
      });
    },
    reloadComponent() {
      this.$forceUpdate(); // Recarga el componente
      this.getSubprojects(); // Opcional: Recargar subproyectos
    },
    applyColor(){
      if(this.frontStyle === 'discord') return;

      if(!this.project || !this.project.options || !this.project.options.primaryColor || !this.project.options.textColor){
        console.log('El proyecto o sus opciones aún no están disponibles');
        return;
      }

      try{
        // Usar this.$el o nextTick para asegurar que el DOM está actualizado
        this.$nextTick(() => {
          const navbar = document.getElementById('mmnavbar');
          console.log('navbar: ', navbar);
          console.log('el primary color es: ', this.project.options.primaryColor);
          if(navbar){
            navbar.style.backgroundColor = this.project.options.primaryColor;
            navbar.style.color = this.project.options.textColor;
          } else {
            console.log('El elemento mmnavbar no existe en el DOM todavía');
          }
        });
      }catch(e){
        console.error('Error al aplicar el color: ', e);
      }
    },
  },
  created() {
    this.$socket.on('new_subproject', () => {
      console.log('[socket] new_subproject');
      this.reloadComponent();
    });
  },
  mounted(){
    this.applyColor();
  },
  beforeUnmount() {
    this.$socket.off('new_meeting');
    this.$socket.off('new_subproject');
  }
}
</script>

<style scoped>
/* Ancho limitado, Altura máxima */
.discord-navbar {
  width: 350px;
  height: 100vh;
  flex-direction: column;
  padding: 10px;
}

/* Altura limitada, ancho máximo */
.classic-navbar {
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  height: 50px;
}



.classic-navbar-item {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.discord-navbar-item.has-unread {
  animation: pulse 1s infinite;
}

@keyframes pulse {
  0% {
    background-color: rgba(255, 0, 0, 0.1);
  }

  50% {
    background-color: rgba(255, 0, 0, 0.3);
  }

  100% {
    background-color: rgba(255, 0, 0, 0.1);
  }
}

.unread-indicator {
  position: relative;
  top: 0;
  right: 0;
  background-color: red;
  color: white;
  border-radius: 50%;
  padding: 2px 6px;
  font-size: 0.8em;
  font-weight: bold;
}


.discord-navbar-item {
  cursor: pointer;
  margin: 5px;
  padding: 5px;
  border-radius: 5px;
  font-weight: 500;
  user-select: none;
  position: relative;
}

.discord-navbar-item:hover {
  background-color: rgba(0, 0, 0, 0.1);
  color: black;
}
</style>